module.exports = __webpack_public_path__ + "img/uam-branco.a794e8a3.svg";